import React, { MouseEvent, ReactNode } from 'react';
import { LayoutInternal } from '@/layout';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import { GridContainer } from '@/features/pacote/PacoteIndex/PacoteIndex.styles';
import CardImage from '@/components/card/CardImage/CardImage';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import { urlPacotes } from '@/config/url';
import FilterListItems from '@/features/pacote/components/FilterListItems/FilterListItems';

export interface PacoteIndexProps {
  data: PacoteDataType;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const PacoteIndex = ({ data, ...props }: PacoteIndexProps) => {
  const { category, destinos } = data;
  const breadcrumbs: BreadcrumbType = [{ path: category.slug, text: category.title }];

  return (
    <LayoutInternal breadcrumbs={breadcrumbs} cover={category.cover}>
      <WhitePaper col={12}>
        <TitleFeatured
          as="h1"
          title={`Pacotes turísticos para mais de ${destinos.length} destinos`}
          description={category.description}
        />
      </WhitePaper>
      <WhitePaper col={12}>
        <FilterListItems initialData={destinos} placeholder="Filtrar Destinos">
          {({ data }) => (
            <GridContainer>
              {data.map(({ title, slug, excerpt, image }, index) => (
                <CardFeatured key={slug}>
                  <CardImage image={image} href={urlPacotes(slug)} priority={index <= 3} />
                  <CardTitle as="h2" textCase="uppercase">
                    <Link href={urlPacotes(slug)}>{title}</Link>
                  </CardTitle>
                  <CardBody>{excerpt}</CardBody>
                  <CardFooter>
                    <Button href={urlPacotes(slug)} block arrow>
                      Pacotes {title}
                    </Button>
                  </CardFooter>
                </CardFeatured>
              ))}
            </GridContainer>
          )}
        </FilterListItems>
      </WhitePaper>
    </LayoutInternal>
  );
};

export default PacoteIndex;
